import type { AxiosError } from '@ori/axios';
import { useSWR } from '@ori/fetching';

import type { UseUserDataParams } from './types';
import { useAppContext } from './useAppContext';
import type { UserData } from '../api';
import { getUserData } from '../api';
import { onUserDataFetchSuccess } from '../utils';

export const useUserData = (params: UseUserDataParams) => {
  const { onlineBaseUrl } = useAppContext();

  const { data, error } = useSWR<UserData, AxiosError>([onlineBaseUrl], async () => getUserData({ onlineBaseUrl }), {
    onSuccess: onUserDataFetchSuccess(params),
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  return {
    userData: data ?? { email: null, telephoneNumber: null },
    loading: data === undefined && error === undefined,
    error,
  };
};
